import { render, staticRenderFns } from "./shxx.vue?vue&type=template&id=369ea07c&scoped=true"
import script from "./shxx.vue?vue&type=script&lang=js"
export * from "./shxx.vue?vue&type=script&lang=js"
import style0 from "./shxx.vue?vue&type=style&index=0&id=369ea07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369ea07c",
  null
  
)

export default component.exports